import Utils from '../../services/Utils'
import { FormErrorStrategy } from '../config/ErrorHandler'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const ReportAdminApi = {
  get: async function (reportId, cancel = false) {
    const response = await GApi.request({
      url: '/global-reporting/report-admin/' + reportId,
      method: 'GET',
      headers: defaultHeaders(),
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },

  put: async function (reportId, userIds, cancel = false) {
    const response = await GApi.request({
      url: '/global-reporting/report-admin/' + reportId,
      method: 'PUT',
      headers: defaultHeaders(),
      data: { userIds },
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.put.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },

  check: async function (reportId, cancel = false) {
    const response = await GApi.request({
      url: '/global-reporting/report-admin-check/' + reportId,
      method: 'GET',
      headers: defaultHeaders(),
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.check.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(ReportAdminApi)

export default ReportAdminApi
